import React, { useState } from 'react';
import '../../../entrydoor.css';

const GlassDividersHorizontalSideLiteEticom = ({ value, onChange, label = 'Horizontal:', disabled = false }) => {
    const [selectedGlassDividersHorizontalSideLiteEticom, setSelectedGlassDividersHorizontalSideLiteEticom] = useState(value || "");
     const [GlassDividersHorizontalSideLiteEticomError, setGlassDividersHorizontalSideLiteEticomError] = useState("");

    const handleGlassDividersHorizontalSideLiteEticomChange = (e) => {
        //setSelectedGlassDividersHorizontalSideLiteEticom(e.target.value);
        validateGlassDividersHorizontalSideLiteEticom(e.target.value);
        onChange(e.target.value);
    };
    const validateGlassDividersHorizontalSideLiteEticom = (value) => {
        const numericValue = value.replace(/\D/g, ""); // Allow only numbers
        setSelectedGlassDividersHorizontalSideLiteEticom(numericValue);
      
        if (numericValue && (numericValue < 0 || numericValue > 10)) {
            setGlassDividersHorizontalSideLiteEticomError('must be between 0" and 10"');
        } else {
            setGlassDividersHorizontalSideLiteEticomError("");
        }
    };
    return (
        <div className="a-container">
            <label style={{ display: "none" }} disabled={disabled} htmlFor="GlassDividersHorizontalSideLiteEticom">{label}</label>
            <input style={{ display: "none" }}
                disabled={disabled}
                id="GlassDividersHorizontalSideLiteEticom"
                value={selectedGlassDividersHorizontalSideLiteEticom}
                onChange={handleGlassDividersHorizontalSideLiteEticomChange}
            >
            </input>
            {GlassDividersHorizontalSideLiteEticomError && <p className="error">{GlassDividersHorizontalSideLiteEticomError}</p>}
        </div>
    );
};

export default GlassDividersHorizontalSideLiteEticom;
